export default __webpack_public_path__ + "static/media/H.e4909308.svg";